import { render, staticRenderFns } from "./InvitedMembersDrawer.vue?vue&type=template&id=4794112a&scoped=true"
import script from "./InvitedMembersDrawer.vue?vue&type=script&lang=js"
export * from "./InvitedMembersDrawer.vue?vue&type=script&lang=js"
import style0 from "./InvitedMembersDrawer.vue?vue&type=style&index=0&id=4794112a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4794112a",
  null
  
)

export default component.exports